export * from './IconArrowRight';
